// extracted by mini-css-extract-plugin
export default {"page":"page_page__a05X7","navbar":"page_navbar__o43e1","logo":"page_logo__3sh1I","content":"page_content__VAfqs"};